const React = require('react')
const PropTypes = require('prop-types')
const SVGInline = require('react-svg-inline').default
const play = require('!!raw-loader!module/icons/svg/play.svg')

function PlaceholderVideo({ video }) {
    const { video_thumbnail } = video

    const style = {}
    if (video_thumbnail) {
        style.backgroundImage = `url(${video_thumbnail})`
    }

    return (
        <div className="video-wrapper placeholder" style={style}>
            <SVGInline svg={play} component="div" className="svg-container" />
        </div>
    )
}

PlaceholderVideo.propTypes = {
    video: PropTypes.object.isRequired,
}

module.exports = PlaceholderVideo
